import PropTypes from 'prop-types';
import React from 'react';
import { colors } from '../../../../colorVars';
import style from './OpenFormButton.module.css';

export const OpenFormButton = ({ size, color, clickHandler, title }) => {
  return (
    <div className={style.div} onClick={clickHandler} title={title}>
      <svg
        className={style.svg}
        width={size}
        height={size}
        viewBox="0 0 36 36"
        version="1.1"
        preserveAspectRatio="xMidYMid meet"
        fill={colors.black}
      >
        <path fill={color} d="M21,12H7a1,1,0,0,1-1-1V7A1,1,0,0,1,7,6H21a1,1,0,0,1,1,1v4A1,1,0,0,1,21,12ZM8,10H20V7.94H8Z"></path>
        <path fill={color} d="M21,14.08H7a1,1,0,0,0-1,1V19a1,1,0,0,0,1,1H18.36L22,16.3V15.08A1,1,0,0,0,21,14.08ZM20,18H8V16H20Z"></path>
        <path fill={color} d="M11.06,31.51v-.06l.32-1.39H4V4h20V14.25L26,12.36V3a1,1,0,0,0-1-1H3A1,1,0,0,0,2,3V31a1,1,0,0,0,1,1h8A3.44,3.44,0,0,1,11.06,31.51Z"></path>
        <path fill={color} d="M22,19.17l-.78.79A1,1,0,0,0,22,19.17Z"></path>
        <path fill={color} d="M6,26.94a1,1,0,0,0,1,1h4.84l.3-1.3.13-.55,0-.05H8V24h6.34l2-2H7a1,1,0,0,0-1,1Z"></path>
        <path fill={color} d="M33.49,16.67,30.12,13.3a1.61,1.61,0,0,0-2.28,0h0L14.13,27.09,13,31.9a1.61,1.61,0,0,0,1.26,1.9,1.55,1.55,0,0,0,.31,0,1.15,1.15,0,0,0,.37,0l4.85-1.07L33.49,19a1.6,1.6,0,0,0,0-2.27ZM18.77,30.91l-3.66.81L16,28.09,26.28,17.7l2.82,2.82ZM30.23,19.39l-2.82-2.82L29,15l2.84,2.84Z"></path>
        {/* <rect fill={color} x={0} y={0} width={36} height={36} /> */}
      </svg>
    </div>
  );
};

OpenFormButton.propTypes = {
  clickHandler: PropTypes.func,
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string
};

